import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID, // Make sure this is set correctly
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
const firebaseConfigCentral = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_CENTRAL,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_CENTRAL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_CENTRAL, // Make sure this is set correctly
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_CENTRAL,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_CENTRAL,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_CENTRAL,
};
// Initialize Firestore

export const app = initializeApp(firebaseConfig);
export const appCentral = initializeApp(firebaseConfigCentral, "central");

// Initialize Firestore and Auth
//export const dbCentral = getFirestore(appCentral);
export const dbCentral = getFirestore(appCentral);

// "One DB" migration: hexagone consolidated Firestore + Auth onto a single
// Firebase project (the one in REACT_APP_FIREBASE_* — foundry-2dlu01 in prod),
// and the backend now mints guest custom tokens for THAT project. The portal
// (testing_react) was migrated; this old iframe was not, so guest sign-in still
// targeted `appCentral` (hexagone-central) and Firebase rejected the
// foundry-signed token with auth/custom-token-mismatch. Point the "central"
// auth at the main app so guest sign-in, token retrieval and the API calls all
// run against the same project the backend signs for. `appCentral` is kept only
// for any legacy central reads still referencing it.
export const getAuthCentral = () => {
  return getAuth(app);
};

// Initialize Firestore and Auth
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
